import "./useBlockStyle.css";

/* eslint-disable import/no-unused-modules -- library export */ /**
 * This will prevent setting CSS variables with empty string values
 * On pages router empty string values are not handled properly,
 * and the server-rendered content is different from the client.
 * Can be removed once the migration to app router is done
 */ const $6431e5a5d80d6395$export$b77a76f72fb195f7 = (value)=>value === '' ? undefined : value;


const $229fc29adde909e7$export$e4982ed41b90c3c8 = (style)=>({
        '--style-background-color-desktop': (0, $6431e5a5d80d6395$export$b77a76f72fb195f7)(style.desktop?.backgroundColor),
        '--style-background-color-mobile': (0, $6431e5a5d80d6395$export$b77a76f72fb195f7)(style.mobile?.backgroundColor)
    });


var $9e695f0f0996e07f$export$44fc8b876749fde6;
$9e695f0f0996e07f$export$44fc8b876749fde6 = `CuRHqW_block-style`;


const $8651d6bf5975686f$export$be602ce1cade3418 = (style)=>style ? {
        blockClassName: $9e695f0f0996e07f$export$44fc8b876749fde6,
        blockStyle: {
            ...(0, $229fc29adde909e7$export$e4982ed41b90c3c8)(style)
        }
    } : {};


export {$8651d6bf5975686f$export$be602ce1cade3418 as useBlockStyle};
//# sourceMappingURL=useBlockStyle.js.map
